module.exports = __webpack_public_path__ + "img/ganxi03.ed17f136.png";